import { createStyles, Theme } from '@material-ui/core/styles';

const style = (theme: Theme) => createStyles({

    FMColorPicker: {

    },
    FMColorPickerButton: {
        width: 48,
        height: 21,
        borderRadius: theme.shape.borderRadius,
    },
    popover: {
        '&>div:nth-child(2)>div>div:nth-child(2)>div:nth-child(2)': {
            display: 'none',
        },
        '&>div:nth-child(2)>div>div:nth-child(2)>div>div:nth-child(2)': {
            display: 'none',
        },
    },
    cover: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
    }
});

export default style;
